var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component content-btn btn-animate"},[(_vm.target === '_blank')?_c('a',{ref:"text",attrs:{"href":_vm.href,"target":_vm.target}},[_c('span',{ref:"span"})]):_c('nuxt-link',{ref:"text",attrs:{"to":_vm.href}},[_c('span',{ref:"span"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }